import { sendGTMEvent } from '@next/third-parties/google';
import type { RecommendedProduct } from '@skin-seoul/service';

const getPageLocation = (): string => {
  if (typeof window === 'undefined') {
    return '';
  }
  return window.location.href;
};

export const trackAICompareImpression = () => {
  sendGTMEvent({
    event: 'ai_compare_impression',
    section: 'smart_product_compare',
    page_location: getPageLocation(),
  });
};

export const trackFilterClick = (filterName: 'more_reviews' | 'lower_price') => {
  sendGTMEvent({
    event: 'ai_compare_filter_click',
    filter_name: filterName,
    section: 'smart_product_compare',
    page_location: getPageLocation(),
  });
};

export const trackRecentlyViewedCarousel = (direction: 'left' | 'right') => {
  sendGTMEvent({
    event: 'ai_compare_recently_viewed_carousel',
    direction,
    section: 'recently_viewed',
    page_location: getPageLocation(),
  });
};

export const trackAIChoiceCarousel = (direction: 'left' | 'right') => {
  sendGTMEvent({
    event: 'ai_compare_ai_choice_carousel',
    direction,
    section: 'ai_choice',
    page_location: getPageLocation(),
  });
};

const formatProductCategory = (categories: string[]): string => {
  return categories.length > 0 ? categories[0] : '';
};

const formatProductVariant = (size: string, pack: string): string => {
  const parts: string[] = [];
  if (size) {
    parts.push(size);
  }
  if (pack) {
    parts.push(`(${pack})`);
  }
  return parts.join('');
};

export const trackAddToCartAICompare = (product: RecommendedProduct) => {
  const price = product.salePrice ?? product.originalPrice;
  const variant = formatProductVariant(product.size, product.pack);

  sendGTMEvent({
    event: 'add_to_cart_ai_compare',
    items: [
      {
        item_id: String(product.productId),
        item_name: product.name,
        item_brand: product.brand,
        item_sku: product.sku,
        item_category: formatProductCategory(product.category),
        item_variant: variant,
        price,
        product_image_url: product.productImageUrls[0] || '',
      },
    ],
    value: price,
    currency: product.currency,
    item_list_name: 'AI Comparison Product',
    section: 'smart_product_compare',
    page_location: getPageLocation(),
  });
};
